import { Slider as DSSlider, cn } from "@aircall/ds";

import type { SliderProps } from "./Slider.decl";

export function Slider({
  id,
  name,
  min = 0,
  max = 100,
  value,
  onChange,
  onMouseUp,
  onMouseDown,
  defaultValue = 0,
  step,
  marks,
  disabled = false,
  hideThumb = false,
  "data-test": dataTest = "slider",
}: SliderProps) {
  const hasMarks = Boolean(marks && marks.length > 0);
  const isControlled = value !== undefined;

  return (
    <div
      className={cn(
        "flex flex-col gap-2",
        disabled
          ? "cursor-not-allowed select-none"
          : "cursor-pointer select-auto"
      )}
      data-test={dataTest}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
    >
      {hasMarks && (
        <div className="relative mx-2 h-5">
          {marks?.map(({ value: markValue, label }) => (
            <span
              key={markValue}
              style={{ left: `${((markValue - min) / (max - min)) * 100}%` }}
              className={cn(
                "absolute -translate-x-1/2 whitespace-nowrap text-sm",
                disabled ? "text-muted-foreground" : "text-foreground"
              )}
            >
              {label}
            </span>
          ))}
        </div>
      )}
      <DSSlider
        data-test={`${dataTest}-input`}
        id={id}
        name={name}
        min={min}
        max={max}
        step={step}
        disabled={disabled}
        value={isControlled ? [value as number] : undefined}
        defaultValue={isControlled ? undefined : [defaultValue]}
        onValueChange={(next) =>
          onChange?.(Array.isArray(next) ? next[0] : next)
        }
        className={cn(hideThumb && "[&_[data-slot=slider-thumb]]:opacity-0")}
      />
    </div>
  );
}
